import { lazy, Suspense,useState,useEffect } from "react";
import "@fontsource/poppins";
import "@fontsource/great-vibes";
import "./App.css";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";
const Header = lazy(() => import("./components/Header/index"));
const Body = lazy(() => import("./components/Body"));
const Benefit = lazy(() => import("./components/Benefits"));
const Guides = lazy(() => import("./components/Guides"));
const Footer = lazy(() => import("./components/FooterNew"));

export default function App() {
  const appVersion = appversion.version;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink|| "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  return (
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      >
        <Suspense fallback={<div />}>
          <Header />
        </Suspense>
        <Suspense fallback={<div />}>
          <Body swmcLink={swmcLink}/>
        </Suspense>
        <Suspense fallback={<div />}>
          <Benefit />
        </Suspense>
        <Suspense fallback={<div />}>
          <Guides />
        </Suspense>
        <Suspense fallback={<div />}>
          <Footer />
        </Suspense>
      </CacheBuster>
    </>
  );
}
